import { IconFn, IconSvg } from "../createIcon";

export const HelpSolidIcon: IconFn = ({ color = "#F56B55", ...props }) => (
  <IconSvg fill="none" viewBox={{ minX: 0, minY: 0, width: 42, height: 42 }} {...props}>
    <g clipPath="url(#clip0_1613_12661)">
      <path
        d="M21.0003 0.166016C9.51283 0.166016 0.166992 9.51185 0.166992 20.9993C0.166992 32.4868 9.51283 41.8327 21.0003 41.8327C32.4878 41.8327 41.8337 32.4868 41.8337 20.9993C41.8337 9.51185 32.4878 0.166016 21.0003 0.166016ZM23.0837 33.4993H18.917V29.3327H23.0837V33.4993ZM25.117 23.3223C24.7087 23.6514 24.3149 23.966 24.0024 24.2785C23.1524 25.1264 23.0857 25.8973 23.0837 25.9306V26.2077H18.917V25.8598C18.917 25.6139 18.9774 23.4077 21.0545 21.3306C21.4607 20.9243 21.9649 20.5118 22.4941 20.0827C24.0232 18.8431 25.0274 17.9389 25.0274 16.6931C25.0032 15.6406 24.568 14.6395 23.815 13.9038C23.062 13.1681 22.051 12.7563 20.9983 12.7566C19.9455 12.7569 18.9347 13.1691 18.1821 13.9052C17.4295 14.6413 16.9948 15.6427 16.9712 16.6952H12.8045C12.8045 12.1764 16.4816 8.49935 21.0003 8.49935C25.5191 8.49935 29.1962 12.1764 29.1962 16.6952C29.1962 20.0223 26.7399 22.0077 25.117 23.3223V23.3223Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_1613_12661">
        <rect width={42} height={42} fill="white" />
      </clipPath>
    </defs>
  </IconSvg>
);
